import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ShoppingCartProvider } from "./components/_default/context/ShoppingCartContext"
import store from "./store/store"
import Redirect from "./components/_default/utilities/Redirect"
import TagManager from 'react-gtm-module'
// Pages
import Webpage1Avaleht from "./pages/Webpage1Avaleht";
import Webpage2Tellimus from "./pages/Webpage2Tellimus";
import Webpage4Privaatsuspoliitika from "./pages/Webpage4Privaatsuspoliitika";
import Webpage5K__psised from "./pages/Webpage5K__psised";
import Webpage6Toode from "./pages/Webpage6Toode";
import Webpage8Lehte_ei_leitud from "./pages/Webpage8Lehte_ei_leitud";

var baseURL = 'https://almaregrill.kassahaldus.ee/webstoreApi';
var axiosHeaders = {
    Authorization: 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiNDVjYTcxMjc2YzJlYjlhZDVhYzEzMjY4ODY1OTA3ZDY2NTIzZmZjOThlMTlkNWEzYWNhMTFmYzI0MDg1ZjU0MDcxMzk5MDg0OWUzNThkMjgiLCJpYXQiOjE3ODQxMTMwNjEuMTE3MDksIm5iZiI6MTc4NDExMzA2MS4xMTcwOTYsImV4cCI6MTc4NDE5OTQ2MS4xMTE3NzgsInN1YiI6IjgiLCJzY29wZXMiOltdfQ.YeYhHlKXEca5jDm9Z1Y3hArC-k8SeHuDTzw7ueNXdhIHkwPLqfUOa-GSzJYoGetZdzVkI6K-npeYX0yfDE2TW8dFDopoj-yGY5jGmrCA_c0LNdIn7NjmFDlkHby2rEeCuL9VRcrIdVmMu-7iEIwkUay57Ii22BSbigbOL_WcefeFocKcDP_8J_aknNUe6eg7KrMLpUhkgtHIRKgfgE_NY8IRoHMIFnGyq8f_BzrlSLLwoCKWWoiFHBMgGuDTBRS59uBALIdhOolKDdkSsooZag_f3Hl592CJHSUTFQdNdJ44hMy3hYDqS9i_Wlbo-vqc71_qHFXAFK_9otKyinUXS08Ince-3U1rN4eQ-TW_VQIrA4UK9IDbx8zqDWOBPgPj2AUMn9BRTKHiHxF6_V8WcUS7zKBuyKc390E6qdXlwa1b6I6kXwNBJHXb5s56n5imf4Mfj3VCwItzmG2KxSyLsptlbiZJ0ygbVj_FNqEupv9oMfeDmabyCOQYE6uhQR9lpIy2vXD4wlwdagDh57yE3tbKFbk9sgcdtOX8zkzu4InnIjWk592JheE1SE-08wTnS_ozhbbdwK166Sg2h4iCdT-rUua6GKFc_xBE8BxYN5_WbUpToXejPmYVIM7ys4KUp1JDcN-rTGf1f-imHXmdq3HWkeNZCYneHf1DYjuNIL8',
    'Access-api-key': "eyJpdiI6ImFqNFhuRVp1Q3F6cHVueVA0d3h2NEE9PSIsInZhbHVlIjoicDVQVEs4RlhuTThXZnNQZThBRnZudz09IiwibWFjIjoiNjhjMzc2MTBkYzA5ODRkYTM1NTc1NTNjMjJkYThhYjA3MGVmYTQ4NzFjOGIzN2NhZDJkYmQ5OGYwOGY5ZTdjMCIsInRhZyI6IiJ9",
    'Access-api-id': "eyJpdiI6ImFScW1HUGl5VWNEWDJOakdPMS92OEE9PSIsInZhbHVlIjoiQysvbTFnazQ3OUlhOXNKS3VkNmtxZz09IiwibWFjIjoiYmVjMWUzZWZlMGE0Y2RjYWRmNDUyY2VjN2U2MzllYjYxYjI5ZjUzMmFlOWE4ZGJlMzJjNGEzODJkODlmNmI3NCIsInRhZyI6IiJ9",
    'Access-Control-Allow-Origin': "*"
 };


window.axios = require('axios').create({
  baseURL: baseURL,
  headers: axiosHeaders
});
const tagManagerArgs = {
    gtmId: "GTM-KZ74CBG6"
}
TagManager.initialize(tagManagerArgs)
    
export default function App() {
    window.dataLayer.push({
        event: 'pageview'
    });
    return (
        <Provider store={store}>
            <ShoppingCartProvider>
                <BrowserRouter basename="/">
                    <Routes>
                                            <Route path="/et/" element={<Webpage1Avaleht />} exact />;
                                                                    <Route path="/et/tellimus" element={<Webpage2Tellimus />} exact />;
                                                                    <Route path="/et/privacyPolicy" element={<Webpage4Privaatsuspoliitika />} exact />;
                                                                    <Route path="/et/cookiePolicy" element={<Webpage5K__psised />} exact />;
                                                                    <Route path="/et/toode/:uuid" element={<Webpage6Toode />} exact />;
                                                                    <Route path="/et/*" element={<Webpage8Lehte_ei_leitud />} exact />;
                                                <Route path="*" element={<Webpage8Lehte_ei_leitud />} exact />;
                                                                
                                                            </Routes>
                </BrowserRouter>
            </ShoppingCartProvider>
        </Provider>
    );
}